<template>
  <div class="row" v-if="answer?.arrayValue?.name && answer?.writerProfile">
    <div class="col-md-3">
      <div class="open__question__row">
        <span class="title">{{ answer.arrayValue.name }}</span>
        <span :class="'badge ' + setBadgeColor(answer.writerProfile)">{{
          setProfileAbreviation(answer.writerProfile)
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { usePlatformStore } from "@/store/platform/platform";

export default {
  name: "OpenedQuestionnaireRowHeadComponent",
  props: {
    answer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(usePlatformStore, {
      apprenticeProfileLabel: (store) => store.apprenticeProfileLabel,
      tutorProfileLabel: (store) => store.tutorProfileLabel,
      apprenticeMasterProfileLabel: (store) => store.apprenticeMasterProfileLabel,
      studeaManagerProfileLabel: (store) => store.studeaManagerProfileLabel,
    }),
  },
  methods: {
    setBadgeColor(profile) {
      switch (profile) {
        case 1:
          return "-apprentice";
        case 2:
          return "-tutor";
        case 3:
          return "-apprenticeMaster";
      }
    },

    setProfileAbreviation(profile) {
      switch (profile) {
        case 1:
          return this.apprenticeProfileLabel.titleAbbreviation
            ? this.apprenticeProfileLabel.titleAbbreviation.toUpperCase()
            : "APP";
        case 2:
          return this.tutorProfileLabel.titleAbbreviation
            ? this.tutorProfileLabel.titleAbbreviation.toUpperCase()
            : "TUT";
        case 3:
          return this.apprenticeMasterProfileLabel.titleAbbreviation
            ? this.apprenticeMasterProfileLabel.titleAbbreviation.toUpperCase()
            : "MAP";
        case 4:
          return this.studeaManagerProfileLabel.titleAbbreviation
            ? this.studeaManagerProfileLabel.titleAbbreviation.toUpperCase()
            : "SM";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.open__question__row {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 10px;
  border-top: 1px solid $grey;
  display: flex;
  justify-content: space-between;

  @include up-to-md {
    flex-direction: column;
  }
}

.badge {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 23px;
  height: 23px;
  font-size: 10px;
  background: $orange;
  margin-left: 10px;

  @include up-to-md {
    margin-top: 10px;
    margin-left: 0;
  }

  &.-apprentice {
    background: $green;
  }

  &.-tutor {
    background: $purple;
  }

  &.-apprenticeMaster {
    background: $red;
  }
}
</style>
